<c-card *transloco="let t">
    <c-card-body class="px-2">
  

        <app-worker-reports-menu></app-worker-reports-menu>

        <div class="row">
          <div class="col-sm-8">
            <h3>{{ t('Report: Monitor Assignment Summary') }}</h3>
            <p>{{ t('A list of monitors with the workers, groups, alert loops and out of hours they are assigned to') }}</p>
          </div>
          <div class="col-sm-4 text-end">
            <button type="button" class="btn btn-light mb-2" aria-expanded="false" (click)="export()">
              <i class="fa-solid fa-file-excel"></i> {{ t('Export Report') }}
            </button>
          </div>
        </div>

          <div class="card mb-2">
            <div class="card-header"data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
            </div>
            <div class="show" id="collapseExample">
              <div class="card-body">

                <form cForm >

                  <div class="row d-flex justify-content-center mb-2">
                      <label  class="col-sm-2 col-form-label text-end"  for="search">
                        <b>{{ t('Search') }}</b>
                      </label>
                      <div class="col-sm-4">
                        <input type="text" class="form-control" id="search" name="search" [(ngModel)]="search" placeholder="{{ t('Name or Email') }}">
                      </div>

                      <label  class="col-sm-2 col-form-label text-end"  for="monitors">
                        <b>{{ t('Monitor') }}</b>
                      </label>
                      <div class="col-sm-4">
                        <ng-select
                        [items]="monitorsList"
                        name="monitor"
                        [(ngModel)]="monitor"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                      </div>
                    </div>

                    <div class="row d-flex justify-content-center mb-2">
                      <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                        <label  class="col-sm-2 col-form-label text-end" for="groups">
                          <b>{{ t('Group') }}</b>
                        </label>
                      <div class="col-sm-4">
                        <ng-select
                        [items]="groups"
                        name="group"
                        [(ngModel)]="group"
                        bindLabel="name"
                        bindValue="id">
                        </ng-select>
                      </div>
                    </ng-container>

                    </div>
                  <div class="row d-flex justify-content-center mb-2">
                    <div class="col-sm-3 d-flex justify-content-end">
                      <button cButton class="btn btn-info text-white" type="submit"  (click)="updateFilter()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                    </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                    <div class="col-sm-3">
                      <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                        <i class="fa-solid fa-xmark"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Clear Filter') }}
                        </span>
                      </button>
                    </div>
                </div>

                </form>

              </div>
            </div>
          </div>

          <c-row *ngIf="monitors">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col">{{ t('Monitor Name') }}</th>
                    <th scope="col">{{ t('Monitor Email') }}</th>
                    <th scope="col">{{ t('Workers') }}</th>
                    <th scope="col">{{ t('Groups') }}</th>
                    <th scope="col">{{ t('Alert Loops') }}</th>
                    <th scope="col">{{ t('Out of Hours') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let monitorItem of monitors">
                      <td>
                        <span><b>{{monitorItem.monitor_name}}</b></span>
                      </td>
                      <td>
                        {{monitorItem.monitor_email}}
                      </td>
                      <td>
                        <div class="small text-medium-emphasis" *ngIf="monitorItem.workers && monitorItem.workers.length > 0">
                          <span *ngFor="let worker of monitorItem.workers; let last = last">
                            {{worker.name}} ({{worker.pin}})<span *ngIf="!last">, </span>
                          </span>
                        </div>
                        <span class="text-muted" *ngIf="!monitorItem.workers || monitorItem.workers.length === 0">{{ t('None') }}</span>
                      </td>
                      <td>
                        <div class="small text-medium-emphasis" *ngIf="monitorItem.groups && monitorItem.groups.length > 0">
                          <span *ngFor="let group of monitorItem.groups; let last = last">
                            {{group.name}}<span *ngIf="!last">, </span>
                          </span>
                        </div>
                        <span class="text-muted" *ngIf="!monitorItem.groups || monitorItem.groups.length === 0">{{ t('None') }}</span>
                      </td>
                      <td>
                        <div class="small text-medium-emphasis" *ngIf="monitorItem.alert_loops && monitorItem.alert_loops.length > 0">
                          <span *ngFor="let alertLoop of monitorItem.alert_loops; let last = last">
                            {{alertLoop.name}}<span *ngIf="!last">, </span>
                          </span>
                        </div>
                        <span class="text-muted" *ngIf="!monitorItem.alert_loops || monitorItem.alert_loops.length === 0">{{ t('None') }}</span>
                      </td>
                      <td>
                        <div class="small text-medium-emphasis" *ngIf="monitorItem.out_of_hours && monitorItem.out_of_hours.length > 0">
                          <span *ngFor="let ooh of monitorItem.out_of_hours; let last = last">
                            {{ooh.name}}<span *ngIf="!last">, </span>
                          </span>
                        </div>
                        <span class="text-muted" *ngIf="!monitorItem.out_of_hours || monitorItem.out_of_hours.length === 0">{{ t('None') }}</span>
                      </td>

                    </tr>
                  </tbody>

              </table>

            </c-col>
          </c-row>

    </c-card-body>
  </c-card>

